import usePendingDocs from './pendingDocsState';
import usePendingDocuments from './usePendingDocuments';

export { usePendingDocs, usePendingDocuments };
